import React, { useState, useRef, useEffect } from "react";
import { loc } from "./Helpers/Localizations"
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import Slide from '@material-ui/core/Slide';
import { ErrorDialogContent, ErrorDialogTitle } from "./Helpers/DialogStyleHelper";

import {
    Redirect
} from "react-router-dom";

export default function Home() {
    const [errorDialogOpen, setErrorDialogOpen] = useState(false);
    const [resultsFound, setResultsFound] = useState(false);

    const inputValueRef = useRef('');

    const Transition = React.forwardRef(function Transition(props, ref) {
        return <Slide direction="up" ref={ref} {...props} />;
    });

    useEffect(() => {
        setErrorDialogOpen(false);
        setResultsFound(false);
      }, []);

    async function handleSubmit(e) {
        e.stopPropagation();
        e.preventDefault();
        let value = inputValueRef.current.value;
        if (value === '') return;

        if (value.indexOf('/') > 0) {
            const valueArray = value.split('/');
            value = valueArray[valueArray.length - 1];
        }

        try {
            const res = await fetch("./.netlify/functions/metrix2?content=result&id="+value);;
            
            const data = await res.json();
            console.log(data);

            if (!res.ok) {
                openDialog();
                return;
            }

            if (res == null || data == null || data["Competition"] == null) {
                openDialog();
            } else {
                console.log(data);
                setResultsFound(true);
                localStorage.setItem('metrixResult', JSON.stringify(data));
            }
        }
        catch (error) {
            console.log(error);
            setResultsFound(false);
            setErrorDialogOpen(true);
        }
    }

    function openDialog() {
        setErrorDialogOpen(true);
    }

    function closeDialog() {
        setErrorDialogOpen(false);
    }


    if (resultsFound) {
        return (<Redirect to='/results'/>);
    }

    if (errorDialogOpen) {
        return (
            <div class="flex items-center justify-center h-screen w-12/12">
                <div class="bg-gray-100 font-bold rounded-lg border shadow-lg p-10 opacity-50">
                    <h1 class="text-3xl text-black">{loc('Put Metrix competition id')}</h1>
                    <form>
                        <input ref={inputValueRef} class="justify-end p-4 text-white bg-gray-600 w-8/12 rounded-lg border shadow-lg opacity-100"
                            type="text" name="metrix_id" id="metrix_id" />
                        <button class="justify-end p-4 w-4/12 text-white bg-gray-900 rounded-lg border shadow-lg opacity-100"
                            type="submit" onClick={handleSubmit}>Get results</button>
                    </form>
                </div>
                <Dialog
                    open={errorDialogOpen}
                    TransitionComponent={Transition}
                    keepMounted
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <ErrorDialogTitle id="alert-dialog-title">{loc('ERROR - NOT FOUND')}</ErrorDialogTitle>
                        <ErrorDialogContent>
                            <DialogContentText id="alert-dialog-description">
                                {loc("Competition with id " + inputValueRef.current.value + " not found")}
                            </DialogContentText>
                        </ErrorDialogContent>
                        <DialogActions>
                            <Button onClick={() => closeDialog()} color="primary" autoFocus>
                                {loc("Close")}
                            </Button>
                        </DialogActions>
                </Dialog>
            </div>)
    }

    return (
        <div class="flex items-center justify-center h-screen w-12/12">
            <div class="bg-gray-100 font-bold rounded-lg border shadow-lg p-10 opacity-50">
                <h1 class="text-3xl text-black">{loc('Put Metrix competition id')}</h1>
                <form>
                    <input ref={inputValueRef} class="justify-end p-4 text-white bg-gray-600 w-8/12 rounded-lg border shadow-lg opacity-100"
                        type="text" name="metrix_id" id="metrix_id" />
                    <button class="justify-end p-4 w-4/12 text-white bg-gray-900 rounded-lg border shadow-lg opacity-100"
                        type="submit" onClick={handleSubmit}>Get results</button>
                </form>
            </div>
        </div>
    );
}
